import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

/**
 * Created vs Resolved Issues report route for CMP projects that do not have a board.
 */
export const cmpCreatedVsResolvedBoardlessRoute: InvariantJiraRoute = {
	name: 'software-reports-created-vs-resolved-cmp-boardless',
	path: '/jira/software/c/projects/:projectKey/reports/created-vs-resolved',
};
